<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="errorMessage" :mensagem="errorMessage" />


    <div v-if="((!modoEdicao) && (!modoVisualizacao))">
        <div class="form-edit-page row-space">
            <div class="row">
                <div class="form-item-rangedata"><DateRangeSelect :periodoInicial="'currentMonth'" v-model="dateRange" /></div>
                <IpOsStatusSelect class="form-item" v-model:statusSelecionado="statusSelecionado" />
                <button type="button" class="buttom-icon--search" @click="lerDados" />
                <button type="button" class="buttom-icon--add" @click="novoCadastro"></button>
                <button type="button" class="buttom-icon--printer" @click="imprimir" />
                <button type="button" class="buttom-icon--close" @click="closeForm" />
            </div>
        </div>
        
        <table class="margin-top10">
            <thead>
                <tr>
                    <th class="col-width-char10">Código</th>
                    <th class="col-width-char10">Data</th>
                    <th class="col-width-char30">Bairro</th>
                    <th>Serviço</th>
                    <th class="col-width-char40">Situação</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(obj, index) in lsDados" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}"  @click="visualizarIpOS(obj)">
                    <td class="col-width-char10 right">{{ obj.cdipos }}</td>
                    <td class="col-width-char10 center">{{ Funcoes.formatDateFromJson(obj.dtipos) }}</td>
                    <td class="col-width-char30">{{ obj.nmbairro }}</td>
                    <td>{{ obj.nmipservico }}</td>
                    <td class="col-width-char40">{{ obj.statusnm }}</td>
                </tr>
            </tbody>
        </table>
    </div>


    <div v-if="modoEdicao">
        <IpOsEditPage :idEdicao="idEdicao" @close="modoEdicao = false" @salvo="lerDados" />
    </div>


    <div v-if="modoVisualizacao">
        <IpOSViewPage :idView="idView" @close="modoVisualizacao = false" />
    </div>
</template>


<script setup>
import { onMounted, ref } from 'vue';
import { Funcoes } from '@/funcoes/utils';
import { genericPost, genericReport } from '@/funcoes/api'; 
import { globalStore } from '@/globals';
import DateRangeSelect from '@/components/DateRangeSelect.vue';
import IpOsEditPage from './IpOsEditPage.vue';
import IpOsStatusSelect from '@/selects/IpOsStatusSelect.vue';
import IpOSViewPage from '../cadastros/visualizacoes/IpOSViewPage.vue';
import MensagemAlerta from '@/components/MensagemAlerta.vue';

const emit = defineEmits(['close']);

const dateRange = ref({ startDate: "", endDate: "", selectedPeriod: "" });
const errorMessage = ref(null);
const idEdicao = ref(0);
const idView = ref(0);
const isLoading = ref(false);
const lsDados = ref([]);
const modoEdicao = ref(false);
const modoVisualizacao = ref(false);
const statusSelecionado = ref(null);

const closeForm = () => {emit('close');}

const imprimir = async() => {
    try{
        Funcoes.validarIntervaloDatas(dateRange.value.startDate, dateRange.value.endDate);
        errorMessage.value = null;
        isLoading.value = true;
        const dados = {
            nmrelatorio: 'ipos_dtipos',
            idmunicipio: globalStore.idmunicipio,
            idusuario: globalStore.idusuario,
            datainicial: dateRange.value.startDate,
            datafinal: dateRange.value.endDate,
            intp1: statusSelecionado.value};
        const response = await genericReport(dados);
        const pdfBlob = new Blob([response], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, '_blank');
    } catch (error){errorMessage.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}

const lerDados = async() => {
    try{
        Funcoes.validarIntervaloDatas(dateRange.value.startDate, dateRange.value.endDate);
        errorMessage.value = null;
        isLoading.value = true;
        const req = await genericPost('/ip/ipos', {
            idmunicipio: globalStore.idmunicipio,
            datainicial: dateRange.value.startDate, 
            datafinal:dateRange.value.endDate,
            intparam1: statusSelecionado.value});
        lsDados.value = req;
    } catch (error){errorMessage.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}

const novoCadastro = () => {
    idEdicao.value = 0;
    modoEdicao.value = true;
}

const visualizarIpOS = (obj) =>{
    idView.value = obj.id;
    modoVisualizacao.value = true;
}

onMounted(lerDados);
</script>
